import RefreshIcon from "@mui/icons-material/Refresh";

type Props = {
    completed: number;
    total: number;
    onRecheck: () => void;
};

export default function DecommissionProgress({ completed, total, onRecheck }: Props) {
    return (
        <div className="decommission-progress">
            <div className="decommission-progress__top">
                <p className="decommission-progress__summary">
                    <strong>{completed} of {total}</strong> steps complete
                </p>

                <button type="button" className="decommission-progress__recheck" onClick={onRecheck}>
                    <RefreshIcon /> Re-check all
                </button>
            </div>

            <div className="decommission-progress__bar" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={completed}>
                <span className="decommission-progress__fill" style={{ width: `${(completed / total) * 100}%` }} />
            </div>
        </div>
    );
}
